import api from './api'
import { AuthMeResponse, LoginCredentials, AuthResponse, UserType } from '@/types/UserType'
import { RegisterTenantPayload } from '@/types/RegisterTenantType'

export async function login(credentials: LoginCredentials): Promise<AuthResponse> {
  const response = await api.post<AuthResponse>('/api/auth/login', credentials, {
    skipGlobalErrorToast: true,
  })
  return response.data
}

export async function logout(): Promise<void> {
  await api.post('/api/auth/logout')
}

export async function registerTenant(
  payload: RegisterTenantPayload,
): Promise<AuthResponse> {
  const response = await api.post<AuthResponse>(
    '/api/auth/tenant/register',
    payload,
    { skipGlobalErrorToast: true },
  )
  return response.data
}

export async function me(): Promise<UserType> {
  const response = await api.get<AuthMeResponse>('/api/auth/me')
  return response.data.user
}

export interface ForgotPasswordPayload {
  email: string
}

export interface ResetPasswordPayload {
  email: string
  token: string
  password: string
  password_confirmation: string
}

export interface MessageResponse {
  message: string
}

export async function forgotPassword(
  payload: ForgotPasswordPayload,
): Promise<MessageResponse> {
  const response = await api.post<MessageResponse>(
    '/api/auth/forgot-password',
    payload,
    { skipGlobalErrorToast: true },
  )
  return response.data
}

export async function resetPassword(
  payload: ResetPasswordPayload,
): Promise<MessageResponse> {
  const response = await api.post<MessageResponse>(
    '/api/auth/reset-password',
    payload,
    { skipGlobalErrorToast: true },
  )
  return response.data
}
